import React from "react";
import { Link } from "react-router-dom";
import { useCurrency } from "../context/CurrencyContext";

export function ProductCard({ product }) {
  const { format } = useCurrency();
  const { main, sub } = format(product.delivered_ghs, product.delivered_gbp);
  return (
    <Link
      to={`/product/${product.id}`}
      data-testid={`product-card-${product.id}`}
      className="group flex flex-col bg-white border border-[#0D530E]/8 rounded-xl overflow-hidden hover:-translate-y-1 hover:shadow-[0_14px_34px_rgba(13,83,14,0.12)] hover:border-[#0D530E]/15"
      style={{ transition: "transform 0.25s ease, box-shadow 0.25s ease, border-color 0.25s ease" }}
    >
      <div className="relative aspect-square overflow-hidden bg-[#E7E1B1]">
        <img src={product.image} alt={product.name} loading="lazy"
          className="w-full h-full object-cover group-hover:scale-105"
          style={{ transition: "transform 0.5s ease" }} />
        <span className="absolute top-2 left-2 bg-white/90 backdrop-blur text-[9px] font-bold tracking-wider uppercase px-2 py-0.5 rounded-full text-[#0D530E]">
          {product.brand}
        </span>
      </div>
      <div className="p-3 flex flex-col gap-1 flex-1">
        <h3 className="font-body text-sm font-medium leading-snug line-clamp-2 text-[#0D530E] min-h-[2.4em]">{product.name}</h3>
        <div className="mt-auto pt-1">
          <p className="font-display text-lg font-semibold text-[#0D530E] leading-none">{main}</p>
          <p className="text-[11px] text-[#306D29]/70 mt-0.5">{sub} · {product.delivery_eta}</p>
        </div>
      </div>
    </Link>
  );
}
